import { render, staticRenderFns } from "./ArchiveVacancy.htm?vue&type=template&id=2e3179e0&scoped=true&"
import script from "./ArchiveVacancy.ts?vue&type=script&lang=js&"
export * from "./ArchiveVacancy.ts?vue&type=script&lang=js&"
import style0 from "./ArchiveVacancy.scss?vue&type=style&index=0&id=2e3179e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3179e0",
  null
  
)

export default component.exports